export enum PermissionToken {
  Camera = "Camera",
}
